import { render, staticRenderFns } from "./Locked.vue?vue&type=template&id=2c87bdff&scoped=true&"
import script from "./Locked.vue?vue&type=script&lang=js&"
export * from "./Locked.vue?vue&type=script&lang=js&"
import style0 from "./Locked.vue?vue&type=style&index=0&id=2c87bdff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c87bdff",
  null
  
)

export default component.exports